module.exports = __webpack_public_path__ + "img/9_of_Diamonds.svg.09e01501.png";